import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/Announcement/Announcement.css'
import setting from '../../../Assets/Announcement/Assets-Desktop/settings.svg';
import arrow from '../../../Assets/Announcement/Assets-Desktop/arrow_right.svg';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { utilityBaseURL } from '../../../Services/config/apiGateway';
import { ALLANNOUNCEMENTS_ENDPOINT } from '../../../Services/config/apiEndPoints';

const Announcement = (props) => {
    let history = useHistory();
    const [announcementData, setAnnouncementData] = useState([]);
    const [newNotification, setNewNotification] = useState(true);
    useEffect(() => {
        ApiCall(
            'GET',
            utilityBaseURL + ALLANNOUNCEMENTS_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    setNewNotification(false);
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    setAnnouncementData(apiData);
                }
            }
        });
    }, [])
    const getTime = (timeStamp) => {
        if (timeStamp) {
            return new Date(timeStamp).toGMTString().split(' ')[4].substring(0, 5)
        }
    }
    const getDate = (timeStamp) => {
        if (timeStamp) {
            let date = new Date(timeStamp).toGMTString();
            let day = date.split(' ')[1];
            let month = date.split(' ')[2];
            let year = date.split(' ')[3];
            return `${day}-${month}-${year}`;
        }
    }
    const handleAnnouncement = (event) => {
        announcementData?.find((name) => {
            if (name.announcementId === announcementData[event].announcementId) {
                history.push({
                    pathname: `/announcementDetails/${name.announcementId}`,
                });
            }
        })
    }
    const handleSettings = () => {
        history.push({
            pathname: '/announcement/notificationSettings'
        });
    }
    return (
        <div>
            <MetaDecorator title={TitleDescription.announcementPageTitle} description={TitleDescription.announcementPageDescription} />
            <Header tilesFetched={() => { }} />
            <div class="annfull">
                <div id="annbox1">
                    <nav className="navbar " class="navbar" id="annnavbar">
                        <div className="navbarname">
                            <small id="navc">Announcements</small>
                        </div>
                    </nav>
                    <hr class="hr1" />
                    <div class="notifaction">
                        <small id="annnotifaction1" onClick={handleSettings}>
                            <img class="mb-1" src={setting} id="checkicon" alt="" loading="lazy" />   &#160;
Notification Settings</small>
                    </div>
                    <div class="maincardAnnouncement">
                        {newNotification ?
                            (announcementData?.map((name, index) => {
                                return (
                                    <div class="navcardannouncement" key={index} onClick={() => handleAnnouncement(index)}>
                                        <div class="announcementrow1">
                                            <div class="anncardin01">
                                                <div class="announcementinput1">
                                                    <small class="annname">{name?.announcementCategory}</small>
                                                </div>
                                                <div class="anncardin02">
                                                    <div class="date1">
                                                        <small id="date">{getDate(name?.publishTime)}</small>
                                                    </div>
                                                    <div class="timeannouncement">  <small id="time" >{getTime(name?.publishTime)}</small>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="anncardimg01" >   <img src={arrow} id="" alt="" loading="lazy" /> </div>
                                        </div>
                                    </div>
                                );
                            }))
                            :
                            <div class="newnotification">
                                <small id="nonotification">No New Announcements</small>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div class="annofooter01">
                <Footer />
            </div>
            <div class="annofooter02">
                <Footer2 />
            </div>
        </div>
    );
}
export default Announcement;